export const PentagonIcon = () => (
    <svg width="40" height="40" viewBox="-60 -60 120 120">
        <polygon
            points={Array.from({ length: 5 }).map((_, i) => {
                const angle = (Math.PI / 2.5) * i - Math.PI / 2;
                const x = 50 * Math.cos(angle);
                const y = 50 * Math.sin(angle);
                return `${x},${y}`;
            }).join(' ')}
            fill="#fff"
            stroke="#333"
            strokeWidth="2"
        />
    </svg>
);
